module.exports = __webpack_public_path__ + "static/media/mirror-example-4.12b588f7.png";